import React, { useState, useEffect } from "react";
import Button from "../../../Components/commonButton/commonButton";
import TextField from "../../../Components/textField/textField";
import Alert from "../../../Components/alert/Alert";
import Dropdown from "../../../Components/select/select";
import Api from "../../../services/api";
import Select from "../../../Components/select/select";
import Notification from "../../../Components/notification/Notification";
import Loading from "../../../Components/loadingNotification/loadingNotification";
import "../general.css";
import "./employee.css";
import { Checkbox } from "../../../Components/Checkbox/checkbox";

const DelEmployee = () => {
  const [show, setShow] = useState(false);
  const [name, setName] = useState("");
  const [employee_code, setEmployee_code] = useState("");
  const [message, setMessage] = useState("");
  const [reload, setReload] = useState(false);
  const [arrData, setArrData] = useState([]);
  const [selectedID, setSelectedID] = useState("");
  const [shifts, setShifts] = useState([{ value: 0, label: "Turno 0" }]);
  const [shiftId, setShiftId] = useState("");
  const [is_active, setIsActive] = useState(false);
  const [id, setId] = useState(null);
  const [readOnly, setReadOnly] = useState(true);
  const [notification, setNotification] = useState(false);
  const [notification_type, setNotificationType] = useState("success");
  const [notification_message, setNotificationMessage] = useState("");

  useEffect(() => {
    let arr = [];
    Api.get("/employees")
      .then((response) => {
        response.data.response.forEach((element) => {
          arr.push({
            value: element.id,
            label: element.name,
            employee_code: element.employee_code,
            is_active: element.is_active,
            id_work_shift: element.id_work_shift,
          });
        });

        setArrData(arr);
      })
      .catch((err) => {
        console.log(err);
        setMessage("Erro de conexão com o servidor.");
        setShow(true);
      });

    Api.get("/work-shifts/")
      .then(({ status, data }) => {
        if (status === 200) {
          let auxarr = [];
          data.forEach(({ id, code }) => {
            auxarr.push({ value: id, label: code });
          });
          setShifts([...auxarr]);
        }
      })
      .catch((err) => {
        console.log(err);
        setMessage("Erro de conexão com o servidor.");
        setShow(true);
      });
  }, []);

  const sendData = () => {
    if (id !== null) {
      Api.delete(`/employees/${id}`, {
        name: name.toUpperCase(),
        code: employee_code,
        is_active: is_active,
      })
        .then((res) => {
          setNotification(true);
          setNotificationType("success");
          setNotificationMessage("Funcionário deletado com sucesso!");
          setTimeout(() => {
            return window.location.reload();
          }, 2000);
        })
        .catch((err) => {
          setMessage("" + err.message);
          setShow(true);
        });
    } else {
      setMessage("Selecione um funcionário.");
      setShow(true);
    }
  };
  const callbackfunction = () => {
    setShow(false);
  };
  const handleSelect = (element) => {
    const { label, value, employee_code, is_active, id_work_shift } =
      arrData.find((v) => v.value == element);
    if (id_work_shift !== null && id_work_shift > 0) {
      const result = shifts.find((e) => e.value == id_work_shift);
      setSelectedID([{ value: id_work_shift, label: result.label }]);
    } else {
      setSelectedID([{ value: 0, label: "Turno 0" }]);
    }
    setIsActive(is_active);
    setName(label);
    setEmployee_code(employee_code);
    setId(value);
    setShiftId(id_work_shift);
    setReadOnly(false);
  };

  const handleSelectShift = (element) => {
    const { value, label } = shifts.find((v) => v.value == element);
    setSelectedID([{ value: value, label: label }]);
    setShiftId(value);
  };

  return (
    <div className="box">
      {notification == true ? (
        <>
          <Notification
            message={notification_message}
            type={notification_type}
          ></Notification>
          <Loading></Loading>
        </>
      ) : (
        <></>
      )}
      <form className="input_fields_alt_employee form">
        <h4>Deletar Funcionário</h4>
        {show ? (
          <Alert
            show={show}
            message={message}
            parentCallback={callbackfunction}
            reload={reload}
          />
        ) : null}
        <div className="inputs">
          <div className="element">
            <Dropdown
              autoSelect={true}
              focus={true}
              label={"Funcionários"}
              arrData={arrData}
              handleSelect={handleSelect}
            />
          </div>
          <div className="element">
            <TextField
              title="Nome Completo"
              value={name}
              validationType="varchar"
              max={60}
              parentCallback={setName}
              readOnly={true}
            />
          </div>
          <div className="element">
            <TextField
              section={true}
              title="Crachá"
              value={employee_code}
              validationType="int"
              max={10}
              parentCallback={setEmployee_code}
              readOnly={true}
            />
          </div>
          <div className="element">
            <Select
              autoSelect={true}
              selectedID={selectedID}
              label="Turno"
              handleSelect={handleSelectShift}
              arrData={shifts}
              isDisabled={true}
            />
          </div>
          <div className="checkboxs">
            <Checkbox label="Ativo" id="ativo" checked={is_active} disabled />
          </div>
        </div>
        <div className="submitButton">
          <Button title="Deletar" icon="del" parentCallback={sendData} />
        </div>
      </form>
    </div>
  );
};
export default DelEmployee;
